<div class="modal-header" mat-dialog-title>
	<h5 class="modal-title"> {{ (!addImageForm.isEdit) ? 'Add Image' : 'Edit Image Attributes' }} </h5>
	<a class="modal-close" mat-dialog-close>&#10005;</a>
</div>
<mat-dialog-content class="mat-add-image">
	<div class="modal-body">
		<div class="information d-flex">
			<div class="col-6">
				<ul class="ul-list">
					<ng-container *ngIf="!addImageForm.isEdit">
						<li>Click upload image button to search for an image</li>
						<li>Enter image attributes</li>
						<li>Click Save button</li>
					</ng-container>
					<ng-container *ngIf="addImageForm.isEdit">
						<li>Modify image attributes</li>
						<li>Click Save button</li>
					</ng-container>
				</ul>
			</div>
			<div class="col-6">
				<label class="specimen-label"><strong>Specimen:</strong> {{addImageForm.specimenCode}}</label>
				<ng-container *ngIf="addImageForm.isEdit">
					<label class="specimen-upload"><strong>Latest Updated By:</strong> {{dailogData.lastUpdatedUser}}</label>
					<label class="specimen-upload"><strong>Latest Updated Date/Time:</strong> {{dailogData.lastUpdated}}</label>
					<label class="specimen-upload"><strong>Image:</strong> {{dailogData.name}}</label>
				</ng-container>
			</div>
		</div>
		<ng-container *ngIf="!addImageForm.isEdit">
			<div class="upload-section">
				<ng-container *ngIf="addImageForm.uploadImage == null">
					<div class="form-group form-upload">
						<label for="uploadImage" class="upload-image">Upload Image</label>
						<input id="uploadImage" type="file" name="upload" class="file-control" (change)="onChangeUploadImage($event)">
					</div>
					<p class="required-note">*Required</p>
				</ng-container>
				<p class="uploaded-image" *ngIf="addImageForm.uploadImage"> <strong>Image:</strong> <a (click)="onClickViewImage()">{{addImageForm.uploadImage}}</a> <a (click)="onClickRemoveImage()" class="remove-icon"></a> </p>
			</div>
		</ng-container>
		<ng-container *ngIf="addImageForm.isEdit">
			<div class="upload-section flex-end">
				<p class="required-note">*Required</p>
			</div>
		</ng-container>
		<div class="row">
			<!-- INTERNAL IMAGE ATTRIBUTES -->
			<div class="col-md-6 col-sm-6">
				<div class="internal-image-block">
					<label class="internal-label">Internal Image Attributes</label>
				</div>
				<div class="form-group">
					<label class="label">Image ID:</label>
					<input type="text" class="form-control" [(ngModel)]="addImageForm.internal.image_id" (keyup)="onKeyUpLength($event, 'internal', 'image_id', 25)">
				</div>
				<div class="form-group">
					<label class="label">Magnification:</label>
					<select class="form-control" [(ngModel)]="addImageForm.internal.magnification">
						<option value="">All</option>
						<option *ngFor="let list of inMagnification" value="{{list.slideTypeCode}}">{{list.description}}</option>
					</select>
				</div>
				<div class="form-group">
					<label class="label"><span class="req">*</span>Sequence #:</label>
					<input type="text" class="form-control" [(ngModel)]="addImageForm.internal.squence" appOnlyNumber (keyup)="onKeyUpValidate($event)" maxlength="3">
					<p class="note">Enter 1-3 digit for Sequence #</p>
					<p class="error" *ngIf="addImageForm.internal.squence == null">This field is required.</p>
				</div>
				<div class="form-group">
					<label class="label">Comment:</label>
					<textarea class="form-control" rows="4" [(ngModel)]="addImageForm.internal.comment" (keyup)="onKeyUpLength($event, 'internal', 'comment', 255)"></textarea>
					<p class="note">255 Character maximum</p>
				</div>
			</div>
			<!-- INTERNAL IMAGE ATTRIBUTES -->
			<!-- EXTERNAL IMAGE ATTRIBUTES -->
			<div class="col-md-6 col-sm-6">
				<div class="internal-image-block">
					<label class="internal-label">External Image Attributes</label>
				</div>
				<div class="form-group">
					<label class="label">Image Type:</label>
					<select class="form-control" [(ngModel)]="addImageForm.external.imagetype" (change)="onChangeImageType($event)" disabled>
						<option value="">All</option>
						<option *ngFor="let list of exImageType" value="{{list.slideTypeCode}}">{{list.description}}</option>
					</select>
				</div>
				<div class="form-group">
					<label class="label">Category:</label>
					<select class="form-control" [(ngModel)]="addImageForm.external.category" (change)="onChangeCategory($event)" disabled>
						<option value="">All</option>
						<option *ngFor="let list of exCategory" value="{{list.slideTypeCode}}">{{list.description}}</option>
					</select>
				</div>
				<div class="form-group">
					<label class="label">Image Sub-Type:</label>
					<select class="form-control" [(ngModel)]="addImageForm.external.imagesubtype" (change)="onChangeImageSubType($event)" disabled>
						<option value="">All</option>
						<option *ngFor="let list of exImageSubType" value="{{list.slideTypeCode}}">{{list.description}}</option>
					</select>
				</div>
				<div class="form-group">
					<label class="label">Image Name:</label>
					<input type="text" name="" class="form-control" [(ngModel)]="addImageForm.external.imagename" (keyup)="onKeyUpLength($event, 'external', 'imagename', 50)">
				</div>
				<div class="form-group">
					<label class="label">Group:</label>
					<input type="text" name="" class="form-control" [(ngModel)]="addImageForm.external.group" (keyup)="onKeyUpLength($event, 'external', 'group', 15)">
				</div>
				<div class="form-group">
					<label class="label">Thumbnail: <input type="checkbox" name="thumbnail" [checked]="addImageForm.external.thumbnail" (change)="addImageForm.external.thumbnail = !addImageForm.external.thumbnail"> </label>
					<div class="thumbnail-view" *ngIf="addImageForm.external.thumbnail">
						<img alt="thumbnail" src="{{addImageForm.thumbnailURL}}" />
					</div>
				</div>
			</div>
			<!-- EXTERNAL IMAGE ATTRIBUTES -->
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions" align="start">
	<button mat-button class="save-btn" [disabled]="addImageForm.disableBtn" (click)="onClickSave()">Save</button>
	<button mat-button mat-dialog-close class="cancel-btn">Cancel</button>
</mat-dialog-actions>

<div #lightbox class="image-lightbox">
	<div class="image-lightbox-top-bar">
		<p class="image-lightbox-text-container desktop-only">
			<span class="image-lightbox-image-label">{{dailogData.mailingID}}</span>
		</p>
		<div (click)="closeImageLightbox()" class="image-lightbox-exit-button">X</div>
	</div>
	<div class="image-lightbox-image-container">
		<img alt="thumbnail-popup" src={{addImageForm.thumbnailURL}} class="image-lightbox-image">
	</div>
	<p class="image-lightbox-text-container mobile-only">
		<span class="image-lightbox-image-label">{{dailogData.mailingID}}</span>
	</p>
</div>